export enum PageType {
    EDIT,
    CONTENT,
    READONLY
}
export interface NavigationOptions {
    readonly pageType?: PageType;
    readonly state?: object;
}

export const defaultNavigationOptions: NavigationOptions = {};
